import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { OverviewScreen } from './OverviewScreen';
import type { PlanHealthScope } from './PlanHealthPanel';
import type { OverviewSearch } from './overview-search';

const route = getRouteApi('/');

export function OverviewRoute() {
  const search = route.useSearch();
  const routeNavigate = route.useNavigate();
  const navigate = useNavigate();

  const onSearchChange = useCallback(
    (next: OverviewSearch) => {
      void routeNavigate({ replace: true, search: () => ({ days: next.days }) });
    },
    [routeNavigate],
  );

  const onOpenPlanScope = useCallback(
    (scope: PlanHealthScope) => {
      if (scope === 'generating') {
        // People, not runs: `plans.generating` counts users with a week in
        // flight, which is what the users list filters on.
        void navigate({ to: '/users', search: { plan: 'generating' } });
        return;
      }
      void navigate({
        to: '/plan-operations',
        search: { status: scope === 'failed' ? 'failed' : 'succeeded_with_residual' },
      });
    },
    [navigate],
  );

  return <OverviewScreen search={search} onSearchChange={onSearchChange} onOpenPlanScope={onOpenPlanScope} />;
}
